export function config() {
    return JSON.parse(localStorage.getItem('config'));
}
